import Ajv from 'ajv'
import * as _ from 'lodash'
import angular from 'angular'
import dataWranglingUtils from '../dataWrangling/utils.js'

const returnPacketValidator = new Ajv().compile({
  title: 'Return Packet',
  type: 'object',
  properties: {
    message: { type: 'string' },
    errors: {
      type: 'array',
      items: { type: 'object' },
    },
  },
  required: ['message', 'errors'],
})

const errorTypes = []

const isInstance = function isInstance(alpha, bravo) {
  /*
   * If _new_ is omitted, it'll still be a type of a function.
   */
  if (typeof alpha !== typeof bravo) {
    return false
  }
  return alpha.constructor === bravo.constructor
}

const ofExceptionType = function ofExceptionType(func) {
  for (let idx = 0; idx < errorTypes.length; idx++) {
    let errorType = errorTypes[idx]
    if (isInstance(errorType, func)) {
      return true
    }
  }
  return false
}

const _ofValidationChecker = function _ofValidationChecker(objectName) {
  let validationType = _.get(
    new customErrors[objectName]({ errors: [], message: 'noop' }),
    'validationType'
  )
  return angular.isDefined(validationType) && validationType === true
}

const ofValidationType = function ofValidationType(objectOrFunc) {
  if (
    angular.isUndefined(objectOrFunc) ||
    objectOrFunc === null ||
    objectOrFunc.constructor === {}.constructor
  ) {
    return false
  }
  return dataWranglingUtils.selectFirst(
    [_.get(objectOrFunc, 'constructor.name'), _.get(objectOrFunc, 'func.name')],
    [[dataWranglingUtils.isStringType, _ofValidationChecker]],
    false
  )
}

const ofReturnPacketType = function ofReturnPacketType(objectLiteral) {
  if (typeof objectLiteral !== 'object') {
    return false
  }
  if ({}.constructor !== objectLiteral.constructor) {
    return false
  }
  return returnPacketValidator(objectLiteral)
}

const validateErrorInput = function validateErrorInput(returnPacket) {
  if (!returnPacketValidator(returnPacket)) {
    throw new customErrors.InvalidPacketError(
      returnPacket,
      returnPacketValidator.errors
    )
  }
  this.packet = returnPacket
  for (let pdx = 0; pdx < returnPacketValidator.schema.required.length; pdx++) {
    let requiredProperty = returnPacketValidator.schema.required[pdx]
    this[requiredProperty] = returnPacket[requiredProperty]
  }
}

const customErrors = {
  // Used to pass datums around the place.
  InvalidPacketError: function InvalidPacketError(invalidPacketError, errors) {
    this.packet = invalidPacketError
    this.errors = errors
  },
  // Used to inform the Engineer
  EllipsisException: function EllipsisException(returnPacket) {
    validateErrorInput.bind(this)(returnPacket)
  },
  MissingMetaTemplateField: function MissingMetaTemplateField(returnPacket) {
    validateErrorInput.bind(this)(returnPacket)
  },
  InvalidAttribute: function InvalidAttribute(returnPacket) {
    validateErrorInput.bind(this)(returnPacket)
  },
  // Used to Inform the user.
  ValidPublicationError: function ValidPublicationError(returnPacket) {
    validateErrorInput.bind(this)(returnPacket)
    this.validationType = true
  },
  UIValidationError: function UIValidationError(returnPacket) {
    validateErrorInput.bind(this)(returnPacket)
    this.validationType = true
  },
}

export default {
  ...customErrors,
  ofReturnPacketType: ofReturnPacketType,
  ofExceptionType: ofExceptionType,
  ofValidationType: ofValidationType,
}
